<template>
  <eg-b-form-checkbox
    :checked="value"
    :value="checkedValue"
    :unchecked-value="uncheckedValue"
    :disabled="disabled"
    :class="computedClass"
    :aria-label="computedAriaLabel"
    switch
    v-bind="$attrs"
    @input="handleInput"
  >
    <slot>{{ label }}</slot>
  </eg-b-form-checkbox>
</template>

<script>
export default {
  name: "EgToggle",
  inheritAttrs: false,
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    value: {
      type: [String, Number, Boolean],
      default: false,
    },
    checkedValue: {
      type: [String, Number, Boolean],
      default: true,
    },
    uncheckedValue: {
      type: [String, Number, Boolean],
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "",
    },
    customClass: {
      type: [String, Array, Object],
      default: null,
    },
    ariaLabel: {
      type: String,
      default: null,
    },
  },
  computed: {
    computedClass() {
      return [this.customClass, "eg-toggle"].filter(Boolean);
    },
    computedAriaLabel() {
      return this.ariaLabel || this.label || undefined;
    },
  },
  methods: {
    handleInput(event) {
      this.$emit("input", event);
    },
  },
};
</script>

<style lang="scss" scoped>
.eg-toggle {
  height: 1.25px;
  ::v-deep {
    label {
      font-size: var(--typography-font-size-fs-300);
      line-height: 1.5rem;
      user-select: none;
    }
    .custom-control-label {
      position: relative;
      cursor: pointer;
      &::before {
        top: 0;
        width: 2.25rem; // 38px
        height: 1.25rem; // 20px
        border-radius: 0.75rem;
        background-color: var(--color-surface-neutral-container-5);
        border: none;
        transition: background-color 0.15s ease-in-out,
          border-color 0.15s ease-in-out;
      }
      &::after {
        top: 2px;
        width: 1rem;
        height: 1rem;
        border-radius: 50%;
        background-color: #fff;
        border: none;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        transition: transform 0.15s ease-in-out;
      }
    }

    .custom-control-input:not(:disabled) {
      &:hover ~ .custom-control-label::before {
        background-color: var(--color-surface-primary-hover) !important;
      }
      &:active ~ .custom-control-label::before {
        background-color: var(--color-surface-neutral-container-5);
      }
    }

    .custom-control-input:checked ~ .custom-control-label {
      &::after {
        transform: translateX(1rem);
      }
      &::before {
        border: none !important;
        background-color: var(
          --color-surface-primary-default,
          #8a3ffc
        ) !important;
      }
    }
    .custom-control-input:focus ~ .custom-control-label::before {
      box-shadow: 0 0 0 0.2rem
        var(--color-surface-primary-opacity-focus, rgba(138, 63, 252, 0.1));
    }
    .custom-control-input:disabled ~ .custom-control-label {
      cursor: not-allowed;
      opacity: 0.6;
    }

    .custom-control-input:disabled ~ .custom-control-label::before {
      background-color: var(--color-surface-neutral-disabled, #f3f4f6);
      border-color: var(--color-stroke-neutral-disabled, #e5e7eb);
    }
  }
}
</style>
